import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Card, Badge, Image } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { ResourceManager } from '../../../core/resource-manager';
import photo from '../../../assets/photo_home_evento.svg'




export default function CardAssociazioni({data}) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);


    useEffect(() => {
        console.log('data-card', data)
        setImage(data.logo ? ResourceManager.getFileUrl(data.logo, 'association') : photo)
    }, []);

    function clickAction() {
        navigate('/associati/' + data.id)
    }


    if (data) {
        return (
            <Container className='my-3'>
                <Card style={{ borderRadius: '20px', backgroundColor: 'white', cursor:'pointer' }} onClick={clickAction}>
                    <Card.Body>
                        <Card.Title>
                            <div className='d-flex'>
                                <div>
                                    <Image src={image} width={50}></Image>
                                </div>
                                <div className='d-flex flex-column ms-3'>
                                    <h5 style={{ color: 'var(--primary-color)' }} className='mb-0'>{data.name}</h5>
                                    <p>{data.subname}</p>
                                </div>
                            </div>
                        </Card.Title>
                        <Card.Text>
                            <span className='mb-3' style={{
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                WebkitLineClamp: 2,
                            }} dangerouslySetInnerHTML={{__html: data.description}}></span>
                            <span className='d-flex'>
                                {data.courses ? <Badge>{data.courses} Corsi</Badge> : null}
                                {data.events ? <Badge className='ms-2'>{data.events} Eventi</Badge> : null}
                            </span>
                        </Card.Text>
                    </Card.Body>
                </Card>

            </Container>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};